import React from 'react';
import "./serverErrorPages.scss";
import { Button } from '../../components';
import { Effect } from '../../assets/svgIcon/customIcon';
import { useTranslation } from 'react-i18next';

interface NotFoundProps {
  errorText?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ errorText = "404" }) => {

  const { t } = useTranslation();
  const handleClick = () => {
    window.location.href = 'https://www.renticy.com/contact-us';
  };

  return (
    <div className='not-found-page'>
      <div className='not-found-content'>
        <div className='not-found-title'>
          <Effect className='error-effect' />
          <h2>{errorText}</h2>
        </div>
        <h4>{t('notfound-page-details')}</h4>
        <Button onClick={handleClick} btnText={'Contact Renticy'} />
      </div>
    </div>
  )
}

export default NotFound
